import SomeoneIMetOnlineExperience from "@/simulations/someone-i-met-online/SomeoneIMetOnlineExperience";

// simulation_id -> dedicated experience implementation. sim_000001 is intentionally absent:
// it keeps using the existing implementation inside SimulationExperience.jsx.
export const EXPERIENCE_MODULES = {
  sim_000002: SomeoneIMetOnlineExperience,
};
